import { apiPrimeSlice } from 'app-redux/store';
import { validateACN } from 'utils';

interface IPaginatedResponse<T> {
  data: T[];
  lastPage: number;
  page: number;
  pageSize: number;
  totalCount: number;
}

export interface ICompanyDetail {
  abn?: string;
  status?: string;
  coType?: string;
  companyName?: string;
  regDate?: string;
  regNo?: string;
  regPlace?: string;
  reviewDate?: string;
}

export interface IPrimeIndividual {
  id?: string;
  surname: string;
  givenName1: string;
  givenName2: string;
  givenName3: string;
  dob: Date;
  pob: string;
  statequalifier: string;
  country: string;
  agentId: string;
  tenantName: string;
  address: {
    state: string;
    postCode: string;
    country: string;
    careOf: string;
    building: string;
    street: string;
    suburb: string;
  };
  mobile: string;
  email: string;
}

const groupsApiSlice = apiPrimeSlice.injectEndpoints({
  endpoints: (builder) => ({
    companiesDetailList: builder.query<IPaginatedResponse<ICompanyDetail>, string>({
      query: (searchKey) => ({
        url: `/Registry/GetCompaniesDetailList`,
        method: 'GET',
        params: validateACN(searchKey) ? { ACN: searchKey } : { companyName: searchKey },
      }),
    }),

    individualEntities: builder.query<IPaginatedResponse<IPrimeIndividual>, string>({
      query: (name) => ({
        url: `/Registry/GetIndividualEntityLookup`,
        method: 'GET',
        params: { request: name },
      }),
    }),
  }),
});

export const { useLazyCompaniesDetailListQuery, useLazyIndividualEntitiesQuery } = groupsApiSlice;
